import Request from './request'

const Settings  = {
  getMonitoringSettings(callback) {
    Request.post('settings/index').then(callback).catch(this.bad_answer)
  },
  updateSettings (id, params, callback) {
    Request.post('settings/update/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default Settings
